/* eslint-disable jsx-a11y/click-events-have-key-events */
/* eslint-disable jsx-a11y/label-has-for */
/* eslint-disable jsx-a11y/label-has-associated-control */
/* eslint-disable jsx-a11y/no-static-element-interactions */
import React, { Component } from "react";
// eslint-disable-next-line import/no-extraneous-dependencies
import { compose } from "redux";
import { connect } from "react-redux";
import { NavLink, withRouter } from "react-router-dom";
import { createLoadingSelector, createErrorSelector, errorActions } from "@a1/core";
import { processActions } from "../../reducer/processReducer";

import logoSplash from "../../images/logo_splash.png";

const actionsNames = ["CHECK_PAIR", "PROCESS_USER"];

class PlanAdd extends Component {
  state = {
    planAcceptChecked: false,
  };

  componentDidMount() {
    document.title = "Преглед на условия - A1 Xplore TV GO";

    const { history, process, clearErrors } = this.props;

    clearErrors(actionsNames);

    if (
      !(
        process.isAddon === true &&
        ((process.token && process.token.length) ||
          (process.email && process.email.length && process.isMigrated === true))
      )
    ) {
      let tokenString = "";
      try {
        tokenString = sessionStorage.getItem("token");
      } catch (err) {
        /* */
      }

      if (tokenString !== "") {
        history.push("/confirm");
      } else {
        history.push("/start");
      }

      return false;
    }

    if (process.token && process.token.length && process.password === null) {
      history.push("/account");
      return false;
    }

    return false;
  }

  componentDidUpdate(prevProps) {
    const { loading, history, process, error } = this.props;

    if (!loading && !(error && error.length) && !(process.processUserResult && process.processUserResult.error)) {
      if (
        process.processUserResult &&
        process.processUserResult.isOk === true &&
        process.processUserResult !== prevProps.process.processUserResult
      ) {
        history.push("/finish");
      }
    }

    return false;
  }

  handlePlanAcceptClick = event => {
    if (event.target.tagName.toLowerCase() === "a") return false;
    const { planAcceptChecked } = this.state;
    this.setState({ planAcceptChecked: !planAcceptChecked });
    return false;
  };

  handleNextClick = event => {
    event.preventDefault();
    const { planAcceptChecked } = this.state;
    const { process, processUser } = this.props;

    if (planAcceptChecked) {
      processUser(
        process.email !== null ? process.email : "",
        process.token !== null ? process.token : "",
        process.password !== null ? process.password : "",
        process.pid !== null ? process.pid : "",
        process.msisdn !== null ? process.msisdn : "",
        process.isAddon === true,
      );
    }

    return false;
  };

  render() {
    const { planAcceptChecked } = this.state;
    const { history, loading, error, process } = this.props;
    const requestError = error && error.length ? error.map(err => <p>{err}</p>) : null;

    let divError = null;

    if (requestError) divError = requestError;
    else if (process.processUserResult && process.processUserResult.error) divError = process.processUserResult.error;

    divError = divError ? (
      <>
        <h1 className="tag-title">Грешка</h1>
        <div className="tag-content">
          <p>Възникна грешка:</p>
          <h3 className="tag-color-red no-break-out">{divError}</h3>
        </div>
        <div className="tag-content tag-content__help" style={{ marginTop: "40px" }}>
          Моля, опитай пак по-късно.{" "}
          <a href="https://help.a1.bg/tv/a1xploretv" className="tag-color-red">
            Помощ
          </a>
        </div>
      </>
    ) : null;

    const divLoading = loading ? (
      <div className="loading">
        <div className="spinner-border" />
      </div>
    ) : null;

    const btnBack = process.isNew ? (
      <button type="button" className="tag-btn--back" onClick={history.goBack}>
        <i className="a1now-icon-arrow_left" /> НАЗАД
      </button>
    ) : null;

    const divContent = divError || (
      <>
        <h1 className="tag-title">Преглед на условия</h1>

        <div className="tag-content">
          <p>{process.planDescription}</p>

          <div className="tag-checkbox" style={{ margin: "60px 0 40px" }} onClick={this.handlePlanAcceptClick}>
            <input type="checkbox" name="planAccept" id="planAccept" checked={planAcceptChecked} readOnly />
            <span className="tag-checkbox__span">
              Приемам&nbsp;
              <NavLink to="/pravila-za-polzvane" className="tag-color-red" target="_blank">
                правилата за ползване
              </NavLink>
            </span>
          </div>
          {divError}
        </div>

        <div className="tag-content">
          <button
            type="button"
            className={planAcceptChecked ? "tag-btn tag-btn--active" : "tag-btn tag-btn--inactive"}
            onClick={this.handleNextClick}
            disabled={!!loading}
          >
            OK
          </button>
        </div>

        <div className="tag-content" style={{ marginTop: "40px" }}>
          A1 Xplore TV GO е услуга предназначена за частни потребители и по никакъв начин не трябва да се използва за
          бизнес цели или публични демонстрации.
        </div>
      </>
    );

    return (
      <div className="page page-confirm">
        <div className="header-bg" />

        <div className="container container--small">
          {divLoading}
          <div className="container-head">
            <img src={logoSplash} alt="" />
            {btnBack}
          </div>
          <div className="container-body">{divContent}</div>
        </div>
      </div>
    );
  }
}

function mapStateToProps(state) {
  return {
    process: state.process,
    loading: createLoadingSelector(actionsNames)(state),
    error: createErrorSelector(actionsNames)(state),
  };
}

function mapDispatchToProps(dispatch) {
  return {
    clearErrors: actions => dispatch(errorActions.clearErrors(actions)),
    processUser: (email, token, password, egn, id, addAddon) =>
      dispatch(processActions.processUser(email, token, password, egn, id, addAddon)),
  };
}

export default compose(
  withRouter,
  connect(
    mapStateToProps,
    mapDispatchToProps,
  ),
)(PlanAdd);
